var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 24,
    viewBox: "0 0 86 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 23,
    rx: 3.5,
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 11 7)",
    fill: "#FF644C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 17 7)",
    fill: "#FF644C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 23 7)",
    fill: "#FF644C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.672 12.724V7.6H35.076V12.652C35.076 13.836 34.764 14.716 34.14 15.292C33.516 15.868 32.656 16.156 31.56 16.156C30.432 16.156 29.56 15.868 28.944 15.292C28.336 14.716 28.032 13.836 28.032 12.652V7.6H29.436V12.724C29.436 13.124 29.484 13.468 29.58 13.756C29.684 14.044 29.828 14.28 30.012 14.464C30.196 14.648 30.416 14.784 30.672 14.872C30.936 14.96 31.232 15.004 31.56 15.004C32.208 15.004 32.72 14.828 33.096 14.476C33.48 14.116 33.672 13.532 33.672 12.724ZM40.8455 8.776H38.7455V11.812H40.8215C41.3175 11.812 41.7015 11.684 41.9735 11.428C42.2535 11.172 42.3935 10.78 42.3935 10.252C42.3935 9.796 42.2695 9.436 42.0215 9.172C41.7735 8.908 41.3815 8.776 40.8455 8.776ZM37.3535 16V7.6H40.9655C41.9175 7.6 42.6255 7.828 43.0895 8.284C43.5615 8.74 43.7975 9.38 43.7975 10.204C43.7975 10.852 43.6615 11.388 43.3895 11.812C43.1175 12.228 42.7295 12.532 42.2255 12.724L43.9175 16H42.3815L40.8335 12.976H38.7455V16H37.3535ZM48.8786 16.156C47.7106 16.156 46.8106 15.804 46.1786 15.1C45.5466 14.388 45.2306 13.284 45.2306 11.788C45.2306 11.012 45.3106 10.352 45.4706 9.808C45.6386 9.256 45.8826 8.808 46.2026 8.464C46.5306 8.112 46.9346 7.856 47.4146 7.696C47.9026 7.528 48.4706 7.444 49.1186 7.444C49.9026 7.444 50.5506 7.572 51.0626 7.828C51.5746 8.084 51.9706 8.5 52.2506 9.076L51.1346 9.748C50.9186 9.332 50.6506 9.036 50.3306 8.86C50.0186 8.684 49.6146 8.596 49.1186 8.596C48.7186 8.596 48.3626 8.644 48.0506 8.74C47.7466 8.836 47.4866 9.004 47.2706 9.244C47.0626 9.484 46.9026 9.812 46.7906 10.228C46.6866 10.636 46.6346 11.156 46.6346 11.788C46.6346 12.412 46.6866 12.932 46.7906 13.348C46.9026 13.756 47.0626 14.088 47.2706 14.344C47.4866 14.592 47.7466 14.768 48.0506 14.872C48.3546 14.976 48.7026 15.028 49.0946 15.028C49.3426 15.028 49.5906 14.996 49.8386 14.932C50.0866 14.86 50.3106 14.744 50.5106 14.584C50.7186 14.424 50.8866 14.212 51.0146 13.948C51.1426 13.684 51.2146 13.352 51.2306 12.952V12.724H49.1426V11.656H52.5146V16H51.4346L51.3506 14.872C51.1186 15.28 50.7866 15.596 50.3546 15.82C49.9226 16.044 49.4306 16.156 48.8786 16.156ZM54.5918 16V7.6H60.7958V8.752H55.9598V11.188H60.1838V12.352H55.9598V14.848H60.9158V16H54.5918ZM68.354 16L63.962 9.736L63.998 16H62.666V7.6H63.914L68.378 13.972L68.342 7.6H69.686V16H68.354ZM71.0779 7.6H77.8459V8.788H75.1579V16H73.7539V8.788H71.0779V7.6Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBadge);
export default __webpack_public_path__ + "static/media/mediumBadge.ebe907ad310e62a0ba6159bc4e09a196.svg";
export { ForwardRef as ReactComponent };